import { Component, Inject, OnInit } from '@angular/core';
import { ModalData, ModalRef, ModalSize } from '@purespectrum1/ui/modal';
import { HighCpiConfirmationActivityGenerator } from '../../domain/high-cpi-confirmation-activity-generator';
import { ActivityLogsService } from '../../../shared/services/activity-logs/activity-logs.service';

@Component({
  selector: 'ps-ui-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.css'],
})
export class ConfirmationModalComponent implements OnInit {
  public data: ConfirmModalData = this._modalData;
  public text!: string[];
  public innerHtml!: string;
  public showCloseButton: boolean = false;
  constructor(
    @Inject(ModalData)
    private _modalData: ConfirmModalData,
    private _activityLogsService: ActivityLogsService,
    private _modalRef: ModalRef<ConfirmationModalComponent, string>
  ) {}

  ngOnInit(): void {
    if (!Array.isArray(this.data.text)) {
      this.text = [this.data.text];
    } else {
      this.text = this.data.text;
    }
    this.showCloseButton = !!this.data.showCloseButton;
    this.innerHtml = this.data.innerHtml;
  }

  close(msg?: string) {
    if (
      msg === 'ok' &&
      this._modalData.ps_survey_id &&
      this._modalData.cpi_current
    ) {
      const activityPayload = new HighCpiConfirmationActivityGenerator(
        this._modalData.ps_survey_id,
        this._modalData.cpi_current
      ).generate();
      this._activityLogsService.post(activityPayload).subscribe();
    }
    this._modalRef.close(msg);
  }
}

interface ConfirmModalData {
  text: string | string[];
  innerHtml: string;
  onlyOneTCLive?: string;
  cancelButtonLabel?: string;
  confirmButtonLabel?: string;
  ps_survey_id?: number;
  cpi_current?: number;
  showCloseButton?: boolean;
  size?: ModalSize;
}
